import React, { useState, useEffect } from 'react'

import Swal from "sweetalert2";
import axios from "axios";
import { apiUrl } from '../../constants';
import { Link, useHistory } from "react-router-dom";
import useQuery from '../../components/useQuery'
import TYCHistory from './TYCHistory'
import TCOHistory from './TCOHistory'
const History = () => {
    const login_token = useQuery();
    const [token, settoken] = useState(login_token)

    const [quota, setquota] = useState(0)
    const history = useHistory();

    const [app_version_data, setapp_version_data] = useState()
    const [device_type_data, setdevice_type_data] = useState()

    useEffect(() => {
        var get_history = localStorage.getItem('history')
        var cover_history = JSON.parse(get_history)
        setquota(cover_history ? cover_history : 0)

        var app_version_data_get = localStorage.getItem('app_version')
        var app_version_data = JSON.parse(app_version_data_get)
        setapp_version_data(app_version_data)
        var device_type_data_get = localStorage.getItem('device_type')
        var device_type_data = JSON.parse(device_type_data_get)
        setdevice_type_data(device_type_data)
    }, [])
    return (
        <div>

            <div className="sticky-headder">
                <div className="headder-cal-group shadow">

                    <div className="row">
                        <div className="col">
                            <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() =>
                                history.push(`/Calculator?login_token=${token}&app_version=${app_version_data}&device_type=${device_type_data}`)
                            }>
                                <path d="M7.35031 0.7256C7.64636 0.4248 8.11244 0.4248 8.40848 0.7256C8.69453 1.01624 8.69453 1.49995 8.40848 1.78991L3.04292 7.24157H19.7485C20.1613 7.24157 20.5 7.57488 20.5 7.99424C20.5 8.4136 20.1613 8.75776 19.7485 8.75776H3.04292L8.40848 14.1992C8.69453 14.5 8.69453 14.9844 8.40848 15.2744C8.11244 15.5752 7.64636 15.5752 7.35031 15.2744L0.714536 8.53216C0.428488 8.24152 0.428488 7.7578 0.714536 7.46784L7.35031 0.7256Z" fill="black" />
                            </svg>

                        </div>
                        <div className="col">
                            <p style={{
                                textAlign: "center",
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: "16px",
                                lineHeight: "19px",
                            }}>

                                History
                            </p>
                        </div>
                        <div className="col">
                            <p style={{ float: "right" }}>
                                {/* <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8.65039 0C3.87291 0 0 3.78737 0 8.45933C0 13.1313 3.87291 16.9187 8.65039 16.9187C10.6937 16.9187 12.5715 16.2259 14.0517 15.0674L16.8633 17.8098L16.9382 17.8728C17.1992 18.0617 17.5693 18.0402 17.8055 17.8086C18.0653 17.5538 18.0648 17.1413 17.8043 16.8873L15.0257 14.1771C16.4384 12.6714 17.3008 10.6639 17.3008 8.45933C17.3008 3.78737 13.4279 0 8.65039 0ZM8.65039 1.30296C12.692 1.30296 15.9684 4.50698 15.9684 8.45933C15.9684 12.4117 12.692 15.6157 8.65039 15.6157C4.60877 15.6157 1.3324 12.4117 1.3324 8.45933C1.3324 4.50698 4.60877 1.30296 8.65039 1.30296Z" fill="#200E32" />
                                </svg> */}
                            </p>

                        </div>
                    </div>

                    {/* <div className="d-flex justify-content-between">
                        <a style={{ color: "#000", fontSize: "30px" }}>Calculator</a>
                        <a style={{ color: "#3b4fbc", fontSize: "16px", textAlign: "right" }}>
                            History
                    </a>
                    </div> */}

                    <div style={{ marginTop: "24px", paddingBottom: "16px", backgroundColor: "#fff" }}>
                        <ul
                            id="pills-tab"
                            role="tablist"
                            className="nav nav-pills d-flex row"
                            aria-orientation="vertical"
                        >
                            <li className={quota === 0 ? "active col-6" : "col-6"} onClick={() => {
                                localStorage.setItem("history", JSON.stringify(0))
                                setquota(0)
                            }}>
                                <a
                                    className={
                                        quota === 0 ? "nav-link active" : "nav-link"
                                    }
                                    id="pills-history-tab"
                                    data-toggle="pill"
                                    href="#pills-history"
                                    role="tab"
                                    aria-controls="pills-history"
                                    aria-selected="true"
                                    aria-expanded="true"
                                    style={{
                                        fontSize: "14px",
                                        color: "#000",
                                        background: "#F6F7FB",
                                        borderRadius: "16px",
                                        textAlign: "center"

                                    }}
                                >
                                    Quotation TCO
                        </a>
                            </li>
                            <li className={quota === 1 ? "active col-6" : "col-6"} onClick={() => {
                                localStorage.setItem("history", JSON.stringify(1))
                                setquota(1)
                            }}>
                                <a
                                    className={
                                        quota === 1 ? "nav-link active" : "nav-link"
                                    }
                                    id="pills-redemption-tab"
                                    data-toggle="pill"
                                    href="#pills-redemption"
                                    role="tab"
                                    aria-controls="pills-redemption"
                                    aria-selected="false"
                                    aria-expanded="true"

                                    style={{
                                        fontSize: "14px",
                                        color: "#000",
                                        background: "#F6F7FB",
                                        borderRadius: "16px",
                                        textAlign: "center"
                                    }}
                                >
                                    3YC Calculator
                        </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginTop: "170px" }}>
            </div>

            <div className="container">
                <div className="tab-content" id="pills-tabContent">
                    <div
                        className={
                            quota === 0
                                ? "tab-pane fade show active row"
                                : "tab-pane fade row"
                        }
                        id="pills-history"
                        role="tabpanel"
                        aria-labelledby="pills-history-tab"
                    >
                        <TCOHistory />

                    </div>
                    <div
                        className={
                            quota === 1
                                ? "tab-pane fade show active row"
                                : "tab-pane fade row"
                        }
                        id="pills-redemption"
                        role="tabpanel"
                        aria-labelledby="pills-redemption-tab"
                    >
                        <TYCHistory />

                    </div>
                </div>
            </div>



        </div >

    )
}

export default History
